// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.F3aAE {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 22px 16px;
  margin-bottom: 22px;
  border-radius: 12px;
  background: #f8f9fa;
  cursor: pointer;
  gap: 12px;
}
.C1Wc1 {
  min-width: 0;
  flex: 1;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}
.fYxo8 {
  min-width: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 2px;
}
.KOpkw {
  width: 100%;
  white-space: nowrap;
  color: #333;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  /* 21px */
  text-transform: capitalize;
  overflow: hidden;
  text-overflow: ellipsis;
}
.FkwJq {
  color: #999;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  /* 18px */
  text-transform: capitalize;
}
.i3UQG {
  width: fit-content;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;
}
.i3UQG span:hover {
  color: #577cf6;
}
.SbIj9 {
  margin-top: 4px;
  color: #ff9500;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  /* 18px */
  text-transform: capitalize;
}
.g0NDq {
  margin-bottom: 22px;
  margin-top: 16px;
  color: #999999;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  /* 24px */
}
.EV_aK {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #999;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  /* 24px */
  text-transform: capitalize;
  margin-bottom: 12px;
  margin-top: 22px;
}
.EV_aK span {
  display: flex !important;
  align-items: center;
}
.qh_bR {
  color: #333;
  border-radius: 10px;
  font-weight: 700;
  height: 32px;
}
.jydcl {
  color: #ffffff;
  background: #577cf6;
  height: 32px;
  border: 1px solid #577cf6;
}
.jydcl:hover {
  border-color: transparent;
}
.jydcl:disabled {
  background: #577cf6;
  color: #fff;
  border-width: 1px;
  opacity: 0.5;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"resumeContent": `F3aAE`,
	"resumeContentFileBox": `C1Wc1`,
	"resumeContentFileBoxItem": `fYxo8`,
	"resumeContentFileBoxItemName": `KOpkw`,
	"resumeContentFileBoxItemSize": `FkwJq`,
	"resumeContentOperateBox": `i3UQG`,
	"uploadCvTip": `SbIj9`,
	"postCvTip": `g0NDq`,
	"openResumeTip": `EV_aK`,
	"sendBtn": `qh_bR`,
	"cvSendButton": `jydcl`
};
export default ___CSS_LOADER_EXPORT___;
